import Service from '../Service'
import {http} from '../config'

export default class ProjetoService extends Service{

    constructor(){
        super('projeto');
    }

    AutoComplete(q) {
        return http.get(this._nomeControle + "/AutoComplete?q=" + q);
    }
  
    IncluirAtividade(projetoId, modelo){
        return http.post(`${this._nomeControle}/${projetoId}/atividade`, modelo);
    }

    IncluirAtividadeItem(projetoId, atividadeId, modelo){
        return http.post(`${this._nomeControle}/${projetoId}/atividade/${atividadeId}/item`, modelo);
    }

    AlterarAtividade(projetoId, atividadeId, modelo){
        return http.put(`${this._nomeControle}/${projetoId}/atividade/${atividadeId}`, modelo);
    }

    AlterarAtividadeItem(projetoId, atividadeId, atividadeItemId, modelo){
        return http.put(`${this._nomeControle}/${projetoId}/atividade/${atividadeId}/item/${atividadeItemId}`, modelo);
    }

    ExcluirAtividade(projetoId, atividadeId){
        return http.delete(`${this._nomeControle}/${projetoId}/atividade/${atividadeId}`);
    }

    ExcluirAtividadeItem(projetoId, atividadeId, atividadeItemId){
        return http.delete(`${this._nomeControle}/${projetoId}/atividade/${atividadeId}/item/${atividadeItemId}`);
    }

    AlterarBeneficiario(projetoId, beneficiarioId, modelo){
        return http.put(`${this._nomeControle}/${projetoId}/beneficiario/${beneficiarioId}`, modelo);
    }

    IncluirBeneficiario(projetoId, modelo){
        return http.post(`${this._nomeControle}/${projetoId}/beneficiario`, modelo);
    }

    IncluirPessoal(projetoId, modelo){
        return http.post(`${this._nomeControle}/${projetoId}/pessoal`, modelo);
    }

    ExcluirBeneficiario(projetoId, beneficiarioId){
        return http.delete(`${this._nomeControle}/${projetoId}/beneficiario/${beneficiarioId}`);
    }

    ExcluirPessoal(projetoId, pessoalId){
        return http.delete(`${this._nomeControle}/${projetoId}/pessoal/${pessoalId}`);
    }

    Replicar(projetoId, dataInicial){
        return http.post(`${this._nomeControle}/replicar`, null, { 
            params: {
                projetoId: projetoId,
                dataInicial: dataInicial
            }
        });
    }

    GetReceitaDespesa(filter){
        return http.get(`${this._nomeControle}/receitadespesa`, {
            params: {
                dataInicial: filter.dataInicial,
                dataFinal: filter.dataFinal
            }
        });
    }

    GetFiltro(parametros, filter){
        
        if (filter) {
            let paramTemp = '';

            if(filter.id && filter.id != 0){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `id eq ${filter.id}`;
            }

            if(filter.nome.length > 0){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `Contains(toupper(nome), toupper('${filter.nome}'))`
            }

            if(filter.tipoId){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `tipoProjetoId eq ${filter.tipoId}`;
            }

            if(filter.aberto != null){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `aberto eq ${filter.aberto}`;
            }
    
            if (paramTemp) {
    
              if(parametros){
                parametros += '&';
              }
              else {
                parametros += '?';
              }
    
              parametros += `$filter=${paramTemp}`;
            }
    
        }
    
        return parametros;
    }

    ListarComFiltro(page, pageSize, sortby, desc, search, columns, filter, include){
        
        let parametros = this.GetParamentroPaginacaoOrdenacao(page, pageSize, sortby, desc, search, columns);
        
        parametros = this.GetFiltro(parametros, filter);

        return http.get(`${this._nomeControle}${parametros}`, this.GetHeader(include));
    }

    TotalizadoresComFiltro(search, columns, filter, include){
        let parametros = this.GetParamentroPaginacaoOrdenacao(null, null, null, [], search, columns);
        parametros = this.GetFiltro(parametros, filter);

        if(parametros === '?'){
            parametros = '';
        }

        const filtroId = filter ? filter.id : null;
        const filtroNome = filter ? filter.nome : null;
        const filtroTipoId = filter ? filter.tipoId : null;

        return http.get(`${this._nomeControle}/Totalizadores${parametros}`, {
            params: {
                filtroId: filtroId,
                filtroNome: filtroNome,
                filtroTipoId: filtroTipoId
            },
            headers: this.GetHeader(include).headers
        });
    }

    Detalhar(id, dataInicio, dataTermino, emissaoInicial, emissaoFinal, competenciaInicial, competenciaFinal){
        return http.get(`${this._nomeControle}/detalhar`, {
            params: {
                id: id,
                dataInicial: dataInicio,
                dataFinal: dataTermino,
                emissaoInicial,
                emissaoFinal,
                competenciaInicial,
                competenciaFinal
            }
        });
    }

    Detalhar2(id, dataInicio, competenciaInicial){
        return http.get(`${this._nomeControle}/detalhar2`, {
            params: {
                id: id,
                dataInicial: dataInicio,
                competenciaInicial
            }
        });
    }

    Beneficiarios(){
        return http.get(`${this._nomeControle}/beneficiarios`);
    }

    VisaoBeneficiarios(projetoId){
        return http.get(`${this._nomeControle}/visaobeneficiarios`, {
            params: {
                projetoId
            }
        });
    }

    ListaHome(pageSize, page){

        return http.get(`${this._nomeControle}/ListaHome`, {
            params: {
                skip: (page - 1) * pageSize,
                top: pageSize
            }
        });
    }
}
